import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

import Table from 'components/table/SimpleTable'
import Window from 'components/dialog/Window'

import routerActions from 'store/modules/router'
import adminActions from 'store/modules/admin'
import adminSelectors from 'store/selectors/admin'
import authSelectors from 'store/selectors/auth'
import bookingformSelectors from 'store/selectors/bookingform'
import bookingformActions from 'store/modules/bookingform'
import projectSelectors from 'store/selectors/project'
import userUtils from 'shared/src/user'

import {
  fullUrl,
} from 'utils/url'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
  },
  title: {
    flexGrow: 1,
  },
  addButton: {
    flexGrow: 0,
  },
  actionButton: {
    margin: theme.spacing(1),
  },
  description: {
    color: '#999'
  }
}))

const FIELDS = [{
  title: 'Name',
  name: 'name',
}, {
  title: 'Links',
  name: 'links',
}, {
  title: 'Description',
  name: 'description',
}]

const BookingForms = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [ deletingItem, setDeletingItem ] = useState(null)
  const data = useSelector(bookingformSelectors.bookingForms)
  const userRole = useSelector(projectSelectors.userRole)
  const projectId = useSelector(projectSelectors.currentProjectId)
  const project = useSelector(projectSelectors.currentProject)

  const onAdd = useCallback(() => {
    dispatch(routerActions.navigateTo('admin.bookingforms.edit', {id: 'new'}))
  })

  const onEdit = useCallback((item) => {
    dispatch(routerActions.navigateTo('admin.bookingforms.edit.config', {id: item.id}))
  })

  const onCalendar = useCallback((item) => {
    dispatch(routerActions.navigateTo('admin.bookingforms.edit.calendar', {
      id: item.id,
      date: 'today',
    }))
  })

  const onSchedule = useCallback((item) => {
    dispatch(routerActions.navigateTo('admin.bookingforms.edit.schedule', {
      id: item.id,
      date: 'today',
    }))
  })

  const onCancelDelete = useCallback(() => {
    setDeletingItem(null)
  })

  const onConfirmDelete = useCallback(async () => {
    const result = await dispatch(adminActions.deleteBookingform(deletingItem.id))
    if(result) {
      setDeletingItem(null)
    }
  }, [
    deletingItem,
  ])
  
  const tableData = useMemo(() => {
    return data.map(bookingform => {
      const url = fullUrl(project, bookingform)
      const item = {
        id: bookingform.id,
        name: bookingform.name,
        description: (
          <Typography variant="caption" className={ classes.description }>
            { bookingform.meta.description }
          </Typography>
        ),
        links: (
          <>
            <Button
              className={ classes.actionButton }
              size="small"
              variant="outlined"
              onClick={ (e) => {
                window.open(url)
              }}
            >
              Public Calendar
            </Button>
            {
              userUtils.hasRole(userRole, 'admin') && (
                <Button
                  className={ classes.actionButton }
                  size="small"
                  variant="outlined"
                  onClick={ (e) => {
                    onCalendar(item)
                    return false
                  }}
                >
                  Admin Calendar
                </Button>
              )
            }
            <Button
              className={ classes.actionButton }
              size="small"
              variant="outlined"
              onClick={ (e) => {
                onSchedule(item)
                return false
              }}
            >
              Schedule
            </Button>
          </>
        )
      }
      return item
    })
  }, [
    userRole,
    data,
    project,
  ])

  const getActions = useCallback((item) => {
    if(!userUtils.hasRole(userRole, 'admin')) return null
    return (
      <>
        <Button
          className={ classes.actionButton }
          size="small"
          variant="outlined"
          onClick={ () => setDeletingItem(item) }
        >
          Delete
        </Button>
        <Button
          className={ classes.actionButton }
          size="small"
          variant="outlined"
          onClick={ (e) => {
            onEdit(item)
            return false
          }}
        >
          Edit
        </Button>
      </>
    )
  }, [
    userRole,
  ])

  useEffect(() => {
    dispatch(bookingformActions.loadAdminBookingforms())
  }, [
    projectId,
  ])

  return (
    <div className={ classes.root }>
      <div className={ classes.toolbar }>
        <div className={ classes.title }>
          <Typography gutterBottom variant="h6">
            Booking Forms
          </Typography>
        </div>
        <div className={ classes.addButton }>
          {
            userUtils.hasRole(userRole, 'admin') && (
              <Button
                variant="contained"
                color="secondary"
                size="small"
                onClick={ onAdd }
              >
                Add Booking Form
              </Button>
            )
          }
        </div>
      </div>
      <div className={ classes.content }>
        <Table
          data={ tableData }
          fields={ FIELDS }
          getActions={ getActions }
        />
      </div>
      {
        deletingItem && (
          <Window
            open
            withCancel
            title="Confirm delete"
            submitTitle="Delete"
            onCancel={ onCancelDelete }
            onSubmit={ onConfirmDelete }
          >
            <Typography>
              Are you absolutely sure you want to delete the { deletingItem.name } booking form?
            </Typography>
          </Window>
        )
      }
    </div>
  )
}

export default BookingForms